module.exports = __webpack_public_path__ + "img/p1-desc.1298c3f9.jpg";